import React from 'react';

const DepartmentCheckboxList = ({ departments, selectedDepartments, onDepartmentChange }) => {
  const handleCheckboxChange = (e) => {
    const value = e.target.value.trim();
    let updatedSelection;

    if (selectedDepartments.includes(value)) {
      updatedSelection = selectedDepartments.filter(dept => dept !== value);
    } else {
      updatedSelection = [...selectedDepartments, value];
    }
    onDepartmentChange(updatedSelection);
  };

  return (
    <div className="department-checkboxes">
      {departments && departments.length > 0 ? (
        departments.map((department, index) => (
          <div key={index}>
            <label>
              <input
                type="checkbox"
                value={department.trim()}
                checked={selectedDepartments.includes(department.trim())}
                onChange={handleCheckboxChange}
                style={{ marginRight: '8px' }}
              />
              {department.trim()}
            </label>
          </div>
        ))
      ) : (
        <p>部署情報がありません。</p>
      )}
    </div>
  );
};

export default DepartmentCheckboxList;
